import { pickT } from "@repo/shared";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { T } from "./order-list-toolbar.i18n";
import { ORDER_STATUSES, orderStatusLabel } from "./order-status-badge";

type OrderListToolbarProps = {
  statusFilter: string;
  onStatusFilterChange: (value: string) => void;
  onRefresh: () => void;
  language: string;
};

export function OrderListToolbar({
  statusFilter,
  onStatusFilterChange,
  onRefresh,
  language,
}: OrderListToolbarProps) {
  const t = pickT(T, language);
  return (
    <div className="flex items-center justify-between">
      <Select value={statusFilter} onValueChange={onStatusFilterChange}>
        <SelectTrigger className="w-[180px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{t.filterAll}</SelectItem>
          {ORDER_STATUSES.map((s) => (
            <SelectItem key={s} value={s}>
              {orderStatusLabel(s, language)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button variant="outline" size="sm" onClick={onRefresh}>
        <RefreshCw className="mr-2 h-4 w-4" />
        {t.refresh}
      </Button>
    </div>
  );
}
